export const advisorsObj = () => ({
    us: [
        {
            name: "Susan Cook-Patton",
            title: "Senior Forest Restoration Scientist, The Nature Conservancy",
            local: "USA",
        },
        {
            name: "KC Cushman",
            title: "Postdoctoral Fellow, NASA JPL",
            local: "USA",
        },
        {
            name: "Grant Domke",
            title: "Forest Carbon Scientist, US Forest Service",
            local: "USA",
        },
        {
            name: "Samuel Favrichon",
            title: "Remote Sensing Scientist, Caltech/NASA JPL",
            local: "USA",
        },
        {
            name: "Ron McRoberts",
            title: "Forest Statistician, Raspberry Ridge Analytics",
            local: "USA",
        },
        {
            name: "Herman Shugart",
            title: "Professor Emeritus of Forest Ecology, University of Virginia",
            local: "USA",
        },

        {
            name: "Miles Silman",
            title: "Professor of Biology and Director, Center for Energy, Environment & Sustainability, Wake Forest University",
            local: "USA",
        },

        {
            name: "Compton Tucker",
            title: "Senior Scientist, NASA Goddard Space Flight Center",
            local: "USA",
        },
    ],
    fr: [
        {
            name: "Jerome Chave",
            title: "Laboratoire Évolution & Diversité Biologique, Université Toulouse Paul Sabatier",
            local: "France",
        },
        {
            name: "Alexandre d'Aspremont",
            title: "Professor of Computer Science, Department at Ecole Normale Superieure",
            local: "France",
        },
    ],
    br: [
        {
            name: "Thelma Krug",
            title: "Vice Chair, IPCC; Former Co-chair, IPCC Task Force on National Greenhouse Gas Inventories",
            local: "Brazil",
        },
    ],
    it: [
        {
            name: "Giacomo Grassi",
            title: "Senior Scientific Officer, Joint Research Centre of the European Commission ",
            local: "Italy",
        },
    ],
    ne: [
        {
            name: "Gert-Jan Nabuurs",
            title: "Professor European Forest Resources, Wageningen University and Research; Lead Scientist European Forest Resources, Wageningen Environmental Research (Alterra)",
            local: "The Netherlands",
        },
    ],
});
